@use "../../styles/breakpoint.module.scss" as *;

.panel {
    grid-column: 4 / span 6;
    padding: var(--spacer-64) var(--spacer-48) var(--spacer-48);
    text-align: center;

    @media ($below-tablet) {
        grid-column: 3 / span 8;
    }

    @media ($below-mobile) {
        grid-column: 1 / -1;
        padding-top: 56px;
    }
}

.title {
    font: var(--font-h-48);
}

.productGroup {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-block: 16px;

    @media ($below-mobile) {
        flex-direction: column;
    }
}

.productInfo {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);

    @media ($above-mobile) {
        text-align: left;
    }
}

.picture {
    position: relative;
    width: 25%;
    aspect-ratio: 1;

    @media ($below-mobile) {
        width: 45%;
        height: 45%;
    }
}

.image {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.sku {
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.productName {
    font: var(--font-p-20);
}
